/* eslint-disable no-console */

type LogArgs = unknown[];

const shouldLog = process.env.NODE_ENV !== 'production';

const createLogger =
  (method: 'log' | 'info' | 'warn' | 'error') =>
  (...args: LogArgs): void => {
    if (!shouldLog) {
      return;
    }

    console[method](...args);
  };

export const logInfo = createLogger('info');
export const logWarn = createLogger('warn');
export const logError = createLogger('error');
export const logDebug = createLogger('log');
